/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Unstarted` - UNSTARTED
 * * `Started` - STARTED
 * * `Blocked` - BLOCKED
 * * `Finished` - FINISHED
 * * `Canceled` - CANCELED
 */
export enum StatusKind {
  UNSTARTED = 'Unstarted',
  STARTED = 'Started',
  BLOCKED = 'Blocked',
  FINISHED = 'Finished',
  CANCELED = 'Canceled',
}
